export const TIPO_FLUJO_TESORERIA = {
  COBRO: 1,
  PAGO: 2,
} as const

export type TipoFlujoTesoreriaType =
  (typeof TIPO_FLUJO_TESORERIA)[keyof typeof TIPO_FLUJO_TESORERIA]
